<template>
  <div class="select-input">
    <select
      :name="captionValueInputName"
      :required="true"
      v-model="captionValue"
      class="select-input__select js-caption-input"
    >
      <option :value="null">Choose...</option>
      <option
        v-for="(choice, choiceIndex) in optionProductCaption.Choices"
        :value="choice"
        :key="choiceIndex"
      >
        {{ choice }}
      </option>
    </select>
  </div>
</template>

<script>import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'SelectInput',
  props: {
    optionProductCaption: { type: Object, default: null, required: true },
    optionProduct: { type: Object, default: null, required: true }
  },
  data: function () {
    return {
      captionValue: null
    }
  },
  computed: {
    captionValueInputName () {
      return `Caption_${this.optionProduct.CatalogPackageOptionProductID}_${this.optionProductCaption.CaptionId}`
    }
  },
  mounted () {
    const configuredText = this.$store.getters.getConfiguredValue(this.captionValueInputName)

    if (configuredText !== null && configuredText.length > 0) {
      this.captionValue = configuredText
    } else if (this.optionProductCaption.DefaultText && this.optionProductCaption.Choices.includes(this.optionProductCaption.DefaultText)) {
      this.captionValue = this.optionProductCaption.DefaultText
    }
  },
  methods: {
    handleInputFocus () {
      GoogleAnalytics.trackEvent(
        'Option Product Caption',
        'focus',
        this.optionProductCaption.CaptionLabel
      )
    }
  }
}</script>

<style lang="scss" scoped>
  @import '../scss/option-product.scss';

  .select-input {
    margin-bottom: 10px;

    @include option-product-form-elements-mixin;
  }
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/CaptionInputs/SelectInput.vue